import * as yup from 'yup';

export const manageBidirectionalTemplateSchema = yup.object().shape({
  domain: yup.string().when('manageTemplate', {
    is: 'maintain',
    then: yup.string().required('* Mandatory field'),
  }),
  newDomain: yup.string().when('manageTemplate', {
    is: 'new',
    then: yup
      .string()
      .required('* Mandatory field')
      .test('len', 'Maximum 50 characters can be entered', (val) => val?.length <= 50)
      .matches(/^[A-Za-z0-9-]*$/, 'Domain name cannot contain special characters except -'),
  }),

  templateType: yup.string().when('manageTemplate', {
    is: 'maintain',
    then: yup.string().required('* Mandatory field'),
  }),
  msgContent: yup.mixed().when('manageTemplate', {
    is: 'maintain',
    then: yup
      .mixed()
      .required('Template content is required')
      .test('is-json-object', 'Template content must be a valid JSON object', (value) => {
        if (!value) return false;
        try {
          const parsed = typeof value === 'string' ? JSON.parse(value) : value;
          return typeof parsed === 'object' && parsed !== null && !Array.isArray(parsed);
        } catch {
          return false;
        }
      }),
    otherwise: yup.mixed().notRequired(),
  }),

  eventName: yup.string().when('manageTemplate', {
    is: 'maintain',
    then: yup
      .string()
      .required('* Mandatory field')
      .matches(/^[A-Za-z0-9-]*$/, 'Event name cannot contain special characters except -'),
  }),
});
